<script>
	import Router, { push } from 'svelte-spa-router';
	import UserStore from './stores/user';
	import routes from './routes.js';

	// the logged-in user (token, company, agent name) is kept in localStorage between visits
	let saved = {};
	try {
		saved = JSON.parse(localStorage.getItem('user') || '{}') || {};
	} catch (e) {
		saved = {};
	}
	UserStore.set(saved);
	if (!saved.data) push('/login');
</script>

<Router {routes} />
